import { navigateTo } from "../wiring/AppDomain";

export enum AppPopups {
    languageselector = "languageselector",
    changepassword = "changepassword",
    imagesupload = "imagesupload",
    excelimexport = "excelimexport",
}
